import { capitalize } from '@local_modules/generic/text/capitalize'
import { index } from 'd3'

// view: period or balance

// account fxConversion: period or balance or history
export const propertyChoices = [
  {
    // eg. PnL lines
    valueType: 'period',
    fxConversion: 'period',
    propertyName: 'valuePeriod'
  },
  {
    // eg. Equity lines
    valueType: 'period',
    fxConversion: 'history',
    propertyName: 'valueHistoryPeriod'
  },
  {
    // eg. Balance Sheet lines
    valueType: 'period',
    fxConversion: 'balance',
    propertyName: 'valueBalanceChange'
  },
  {
    // eg. Translation Reserve lines
    valueType: 'period',
    fxConversion: 'revaluation',
    propertyName: 'valueRevaluationChange'
  },
  //
  // BALANCES
  {
    valueType: 'balance',
    fxConversion: 'period',
    propertyName: 'valuePeriodsCumul'
  },
  {
    valueType: 'balance',
    fxConversion: 'history',
    propertyName: 'valueHistoryPeriodsCumul'
  },
  {
    valueType: 'balance',
    fxConversion: 'balance',
    propertyName: 'valueBalance'
  },
  {
    // eg. Translation Reserve lines
    valueType: 'balance',
    fxConversion: 'revaluation',
    propertyName: 'valueRevaluationBalance'
  }
]

const propertyChoiceMap = index(propertyChoices,
  d => d.valueType,
  d => d.fxConversion
)

export function valuePropertyToUse (valueType, fxConversion) {
  const propertyChoice = propertyChoiceMap.get(valueType)?.get(fxConversion)
  return propertyChoice?.propertyName
}

export function getDbProperty (valueType) {
  const targetValueType = valueType || 'period'
  const dbProperty = `for${capitalize(targetValueType)}`
  return dbProperty
}
